import { EventNameSocket } from '@/common/constant'

const globalEvents: Record<string, string> = {
  ReadySendRequest: 'ReadySendRequest',
  DoExercise: 'DoExercise',
  SaveExercise: 'SaveExercise',
  AddAndRemoveListener: 'AddAndRemoveListener',
  ShowHelp: 'ShowHelp',
  EditStudentExam: 'EditStudentExam',
  NextStudent: 'NextStudent',
  RingBell: EventNameSocket.RingBell,
  CloseExam: EventNameSocket.CloseExam,
  OpenExam: EventNameSocket.OpenExam,
  JoinDate: EventNameSocket.JoinDate,
  SubmitDate: EventNameSocket.SubmitDate,
  StudentIsReady: EventNameSocket.StudentIsReady,
  StudentIsNotReady: EventNameSocket.StudentIsNotReady,
  SendMark: EventNameSocket.SendMark,
  WithdrawMark: EventNameSocket.WithdrawMark,
  OnEditorViewerReady: 'OnEditorViewerReady',
  LikeComment: EventNameSocket.LikeComment,
  ReplyCommnet: EventNameSocket.ReplyComment,
  TagUser: EventNameSocket.TagUser,
  AutoJoinClassroomSuccess: EventNameSocket.AutoJoinClassroomSuccess,
  OnCallBackGoogleImage: 'OnCallBackGoogleImage',
  CheckRankingConifg: 'CheckRankingConifg'
}

export { globalEvents }
